import { Button } from "../../atoms/Button";
import Container from "../../atoms/Container";
import { Icon } from "../../atoms/Icon";
import { Typography } from "../../molecules/Typography";

interface INoContentProps {
  url: string;
}

const NoContent: React.FC<INoContentProps> = ({ url }) => {
  return (
    <Container>
      <div className='h-[85vh] flex flex-col items-center justify-center'>
        <div className='flex w-full flex-col items-center justify-center gap-xxl'>
          <Typography variant='italic' className='text-center'>
            Este conteúdo está indisponivel neste momento
          </Typography>
          <div className='relative w-full'>
            <div className='m-auto h-64 w-64 rounded-circular bg-mono-color-light' />
            <div className='absolute top-14 flex h-full w-full flex-col items-center gap-lg'>
              <div className='ml-10 flex h-fit flex-row items-center gap-lg rounded-md bg-mono-color-white p-2 shadow-level-1 xs:w-[250px] md:w-[260px]'>
                <div className='flex h-12 w-12 items-center justify-center rounded-circular bg-brand-color-secondary-light'>
                  <Icon
                    Icon='sentiment_very_dissatisfied'
                    type='material'
                    className='text-mono-color-white'
                  />
                </div>
                <div className='flex flex-1 flex-col gap-sm'>
                  <div className='h-3 w-1/3 rounded-pill bg-mono-color-lightest' />
                  <div className='h-3 w-3/5 rounded-pill bg-mono-color-lighter' />
                </div>
              </div>
              <div className='mr-10 flex h-fit flex-row items-center gap-lg rounded-md bg-mono-color-white p-2 shadow-level-1 xs:w-[250px] md:w-[260px]'>
                <div className='flex h-12 w-12 items-center justify-center rounded-circular bg-brand-color-secondary-light'>
                  <Icon
                    Icon='sentiment_very_dissatisfied'
                    type='material'
                    className='text-mono-color-white'
                  />
                </div>
                <div className='flex flex-1 flex-col gap-sm'>
                  <div className='h-3 w-1/3 rounded-pill bg-mono-color-lightest' />
                  <div className='h-3 w-3/5 rounded-pill bg-mono-color-lighter' />
                </div>
              </div>
            </div>
          </div>
          <Button LeftIcon="chevron_left" iconType="material" variant="outlined" asLink to={url}>
            Voltar para a página anterior
          </Button>
        </div>
      </div>
    </Container>
  )
}

export default NoContent;